import { render } from "./SiteStudies.vue?vue&type=template&id=6127f592&ts=true"
import script from "./SiteStudies.ts?vue&type=script&lang=ts"
export * from "./SiteStudies.ts?vue&type=script&lang=ts"

import "./SiteStudies.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__